import React from 'react';

import classNames from 'classnames';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import Biography from '../../../components/common/Biography';
import { Link, Pill } from '../../../components/elements';
import { ISelectedBlog } from '../Blog.types';
import SocialsPopover from '../BlogCard/SocialsPopover';
import { getReadTime } from '../helpers';
import BlogPostStyles from './BlogPost.module.scss';

const BlogPost = ({
  data: {
    img,
    category,
    title,
    tags,
    author,
    authorAt,
    authorTexts,
    authorImg,
    body,
    date,
    updated,
    slug,
    biography,
  },
}: ISelectedBlog) => {
  return (
    <div className={BlogPostStyles.blogPostWrapper}>
      <img loading="lazy" className={BlogPostStyles.visual} src={img.path} alt={img.alt} />
      <div className={BlogPostStyles.contentWrapper}>
        <div className={BlogPostStyles.headerWrapper}>
          <span className={BlogPostStyles.eventType}>{category}</span>
          <h1 className={BlogPostStyles.title}>{title}</h1>
          {!!tags.length && (
            <div className={BlogPostStyles.tagsWrapper}>
              {tags.map((item) => (
                <Pill label={item} key={item} />
              ))}
            </div>
          )}
        </div>

        <div className={BlogPostStyles.blogDetails}>
          <div className={BlogPostStyles.author}>
            {!!authorImg.path && (
              <img className={BlogPostStyles.authorImg} src={authorImg.path} alt={authorImg.alt} />
            )}
            <div className={BlogPostStyles.authorInfo}>
              <p>
                {authorTexts.text1}
                <strong>
                  {author ? (
                    <Link to="/authors/" variant="dark" style={{ textDecoration: 'underline' }}>
                      {author}
                    </Link>
                  ) : (
                    <Link to="/authors/" variant="dark" style={{ textDecoration: 'underline' }}>
                      {authorTexts.defaultText}
                    </Link>
                  )}
                  {authorAt && authorTexts.text2}
                  {authorAt}
                </strong>
              </p>
              <div className={BlogPostStyles.detailsControls}>
                <SocialsPopover title={title} url={slug} />
                <span className={BlogPostStyles.readTime}>{getReadTime(body)}</span>
                <p
                  className={classNames(
                    BlogPostStyles.publishedDate,
                    BlogPostStyles.publishedDateMobile
                  )}
                >
                  {date}
                </p>
              </div>
            </div>
          </div>
          <div className={BlogPostStyles.dateDetails}>
            <p className={BlogPostStyles.publishedDate}>Created: {date}</p>
            <p className={BlogPostStyles.publishedDate}>Updated: {updated}</p>
          </div>
        </div>

        <ReactMarkdown className={BlogPostStyles.blogDescription} rehypePlugins={[rehypeRaw]}>
          {body}
        </ReactMarkdown>
        {!!biography.body && <Biography biography={biography} />}
      </div>
    </div>
  );
};

export default BlogPost;
